import { Grid, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { memo } from "react";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
  useResetRecoilState,
} from "recoil";
import queryString from "query-string";
import CalendarVertical from "src/SearchHours/components/calendars/CalendarVertical";
import {
  dayDefaultAvailableState,
  showCalendarHorizontalState,
} from "src/SearchHours/components/calendars/state/atoms";
import FiltersSearch from "src/SearchHours/FiltersSearch";
import useSearchHours from "src/SearchHours/hooks/useSearchHours";
import {
  capitalizeWord,
  serializeDateFormatLong,
  nameSede,
  cleanRut,
} from "src/shared/global/helpers";
//import ListProfessionals from './components/ListProfessionals';
import ListProcedimiento from "./components/ListProcedimientosCentral";
import {
  existPatientState,
  filterSearchSelectedState,
  hoursAvailableState,
  loadingDaysCalendarState,
  loadingHoursState,
} from "src/SearchHours/state/atoms";
import { useRef } from "react";
import AlertCustom from "src/shared/components/alerts/AlertCustom";
import HoursAvailableSkeleton from "src/shared/components/skeletons/HoursAvailableSkeleton";
import useSEO from "src/Hooks/useSEO";
import ModalReservationImagenologia from "src/Reservation/ModalReservationImagenologia";
import ModalRut from "src/shared/components/modals/ModalRut";
import { agendamientoInconclusoState } from "src/ResultSearch/state/atoms";
import AgendamientoInconcluso from "src/services/agenda/agendamientoInconcluso";
import { userState } from "src/store/user/userState";
import { valuesFormReservationGuestState } from "src/Patient/state/atoms";

const Index = memo(() => {
  const dayDefaultAvailable = useRecoilValue(dayDefaultAvailableState);
  const hoursAvailable = useRecoilValue(hoursAvailableState);
  const loadingHours = useRecoilValue(loadingHoursState);
  const setShowCalendarHorizontal = useSetRecoilState(
    showCalendarHorizontalState
  );
  const [filterSearchSelected] = useRecoilState(filterSearchSelectedState);
  const setFilterSearchSelected = useSetRecoilState(filterSearchSelectedState);
  const resetFilterSearchSelected = useResetRecoilState(
    filterSearchSelectedState
  );
  const {
    loadDaysAvailableProcedimientoAndDefault,
    loadHoursProcedimientoAvailable,
    loadDaysAvailableAndDefault,
    loadHoursAvailable,
    isEmptyFilters,
    isEmptyFiltersProcedimiento,
  } = useSearchHours();
  const loadingDaysCalendar = useRecoilValue(loadingDaysCalendarState);
  const location = useLocation();
  const query = queryString.parse(location.search);
  const mountedC = useRef(false);
  const query2 = queryString.parse(window.location.search);
  //useSEO({title: 'Reagendar'});
  //{query2 && query2.ra_id !== undefined && query2.ra_id !== "" && useSEO({title: 'Reagendar'})}
  const [showLoading, setShowLoading] = useState(true);
  const history = useNavigate();

  const initSEO = () => {};
  useEffect(() => {}, []);

  useEffect(() => {
    mountedC.current = true;
    setShowCalendarHorizontal(true);
    return () => {
      mountedC.current = false;
      setShowCalendarHorizontal(false);
    };
  }, []);

  useEffect(() => {
    const queryParamsLength = !query ? 0 : Object.keys(query).length;
    loadDaysAvailableProcedimientoAndDefault();
  }, [loadDaysAvailableProcedimientoAndDefault]);

  useEffect(() => {
    if (dayDefaultAvailable && !loadingHours && hoursAvailable.length === 0) {
      loadHoursProcedimientoAvailable();
      setTimeout(() => setShowLoading(false), 1000);
    }
  }, [dayDefaultAvailable]);

  const [valueAgendamientoInconcluso, setValueAgendamientoInconcluso] =
    useRecoilState(agendamientoInconclusoState);
  const valueRef = useRef();
  const user = useRecoilValue(userState);
  const valuesFormReservationGuest = useRecoilValue(
    valuesFormReservationGuestState
  );
  const userRut = user.isAuthenticated
    ? user.payload?.uswRut?.trim()
    : valuesFormReservationGuest.uprRut;

  valueRef.current = {
    ...valueAgendamientoInconcluso,
    agiRut: cleanRut(userRut ? userRut : ""),
    ptdRut: valueAgendamientoInconcluso?.ptdRut
      ? valueAgendamientoInconcluso.ptdRut
      : filterSearchSelected.professionalSelected.code,
  };
  console.log("inconcluso", valueRef);

  const handleBeforeUnload = (event) => {
    const body = {
      ptdRut: valueRef.current?.ptdRut,
      agpCorrel: valueRef.current?.agpCorrel?.toString(),
      agiRut: valueRef.current?.agiRut?.toString(),
      empCodigo: valueRef.current?.empCodigo?.toString(),
      espCodigo: valueRef.current?.espCodigo?.toString(),
      sueCorrel: valueRef.current?.sueCorrel?.toString(),
      tapTipo: valueRef.current?.tapTipo?.toString(),
      isaCodigo: valueRef.current?.isaCodigo?.toString(),
      agiTipo: "PCD",
      agiFechaBuscada: valueRef.current?.agiFechaBuscada,
    };

    AgendamientoInconcluso.save(body)
      .then(() => {
        console.log("Agendamiento guardado correctamente.");
      })
      .catch((error) => {
        console.error("Error al guardar agendamiento inconcluso:", error);
      });
    event.preventDefault();
    event.returnValue = ""; // Requerido para navegadores modernos.
  };

  useEffect(() => {
    // Actualiza la referencia cada vez que el valor de Recoil cambie.

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const [existPatient, setExistPatient] = useRecoilState(existPatientState);

  useEffect(() => {
    const storedExistPatient = sessionStorage.getItem("existPatientState");
    if (storedExistPatient) {
      setExistPatient(JSON.parse(storedExistPatient));
    }

    const checkPatient = async () => {
      if (userRut && !existPatient) {
        try {
          const { data } = await AgendamientoInconcluso.existPatient(
            cleanRut(userRut)
          );
          console.log("response existPatient", data);
          if (data) {
            console.log("setExistPatient true");

            setExistPatient(data);
          } else {
            console.log("setExistPatient false");
            setExistPatient(data);
          }
        } catch (error) {
          console.error("Error checking patient existence:", error);
        }
      }
    };

    checkPatient();
  }, []);

  return (
    <Grid container paddingY={2}>
      {query &&
      Object.keys(query).length > 0 &&
      query.ra_id !== undefined &&
      query.ra_id !== "" ? (
        <AlertCustom
          severity="info"
          children={
            <>
              Anteriormente realizó una reserva para el día{" "}
              <strong>
                {capitalizeWord(
                  serializeDateFormatLong(
                    new Date(sessionStorage.getItem("dateReservationCanceled"))
                      ?.toISOString()
                      .split("T")[0]
                  ),
                  true
                )}{" "}
                con el Dr(a) {filterSearchSelected.professionalSelected.value}
              </strong>
              . Puede volver a agendar una nueva hora para el mismo día o la
              fecha que usted desee.
            </>
          }
          style={{ marginBottom: 16, width: "100%" }}
        />
      ) : null}
      <ModalReservationImagenologia />
      <ModalRut />
      <Grid item xs={12} md={8} lg={9}>
        <FiltersSearch />
        <Typography
          variant="h3"
          color={grey[700]}
          mb={2}
          style={{ textTransform: "uppercase" }}
        >
          {serializeDateFormatLong(
            dayDefaultAvailable?.toISOString().split("T")[0]
          )}
        </Typography>
        {showLoading === false ? (
          (loadingHours || loadingDaysCalendar) &&
          hoursAvailable.length === 0 ? (
            <HoursAvailableSkeleton />
          ) : (
            <ListProcedimiento />
          )
        ) : (
          <HoursAvailableSkeleton />
        )}
      </Grid>

      <Grid item xs={12} md={4} lg={3} paddingLeft={2}>
        <CalendarVertical />
      </Grid>
    </Grid>
  );
});

export default Index;
